var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    {
      staticClass: "tile-layout",
      attrs: { row: "", wrap: "", "fill-height": "" },
    },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "", "pa-1": "" } },
        [
          _c("v-text-field", {
            attrs: {
              box: "",
              label: "Header",
              disabled: "",
              "hide-details": "",
            },
            model: {
              value: _vm.columnData.Header,
              callback: function ($$v) {
                _vm.$set(_vm.columnData, "Header", $$v)
              },
              expression: "columnData.Header",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md3: "", "pa-1": "" } },
        [
          _c("v-text-field", {
            attrs: { box: "", label: "Type", disabled: "", "hide-details": "" },
            model: {
              value: _vm.columnData.ValueType,
              callback: function ($$v) {
                _vm.$set(_vm.columnData, "ValueType", $$v)
              },
              expression: "columnData.ValueType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md3: "", "pa-1": "" } },
        [
          _c("v-text-field", {
            attrs: {
              box: "",
              label: "Strictness",
              disabled: "",
              "hide-details": "",
            },
            model: {
              value: _vm.columnData.Strictness,
              callback: function ($$v) {
                _vm.$set(_vm.columnData, "Strictness", $$v)
              },
              expression: "columnData.Strictness",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }